import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';

export default component$(
  ({
    cssClasses,
    active = false,
  }: {
    cssClasses: string;
    active?: boolean;
  }): JSX.Element => {
    return active ? (
      <svg
        width='22'
        height='22'
        viewBox='0 0 24 23'
        xmlns='http://www.w3.org/2000/svg'
        class={cssClasses}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M4.253 2.353a1.203 1.203 0 00-1.703 0c-.47.471-.47 1.235 0 1.706l7.658 7.669-7.855 7.867c-.47.47-.47 1.234 0 1.705.47.471 1.232.471 1.702 0l7.856-7.867 7.848 7.86c.47.47 1.232.47 1.702 0 .47-.471.47-1.235 0-1.706l-7.847-7.86 7.623-7.635c.47-.47.47-1.234 0-1.705a1.203 1.203 0 00-1.702 0l-7.624 7.635-7.658-7.669z'
        />
      </svg>
    ) : (
      <svg
        width='22'
        height='22'
        viewBox='0 0 24 20'
        xmlns='http://www.w3.org/2000/svg'
        class={cssClasses}
      >
        <path
          fill-rule='evenodd'
          clip-rule='evenodd'
          d='M1.5 0a1.5 1.5 0 000 3h14.18a1.5 1.5 0 100-3H1.5zM0 10a1.5 1.5 0 011.5-1.5h21a1.5 1.5 0 010 3h-21A1.5 1.5 0 010 10zm0 8.5A1.5 1.5 0 011.5 17h6.357a1.5 1.5 0 010 3H1.5A1.5 1.5 0 010 18.5z'
        ></path>
      </svg>
    );
  }
);
